var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3379 21.666C27.8607 21.666 32.3379 17.1889 32.3379 11.666C32.3379 6.14317 27.8607 1.66602 22.3379 1.66602C16.815 1.66602 12.3379 6.14317 12.3379 11.666C12.3379 17.1889 16.815 21.666 22.3379 21.666Z",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3731 12.3672C8.20923 12.0705 4.29913 14.3916 2.56552 18.189C0.831906 21.9864 1.63956 26.4612 4.59133 29.413C7.5431 32.3648 12.0179 33.1724 15.8153 31.4388C19.6128 29.7052 21.9338 25.7951 21.6371 21.6312",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0059 18.9993V17.666",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 19H10.2941C9.43729 19.0006 8.70114 19.6085 8.53855 20.4498C8.37595 21.291 8.83255 22.1295 9.62745 22.4493L12.3795 23.5507C13.1743 23.8705 13.631 24.709 13.4684 25.5502C13.3058 26.3915 12.5696 26.9994 11.7128 27H8.99945",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0059 28.3333V27",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3379 7.66536V6.33203",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 7.66602L21.6281 7.66602C20.7713 7.66661 20.0351 8.27454 19.8725 9.1158C19.7099 9.95706 20.1665 10.7955 20.9614 11.1153L23.7134 12.2167C24.5083 12.5365 24.9649 13.375 24.8023 14.2162C24.6397 15.0575 23.9036 15.6654 23.0468 15.666H20.3334",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3379 16.9993V15.666",
    stroke: "#3B4B59",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCoins);
export default __webpack_public_path__ + "static/media/money-coins.125035bbdcc9832759b87e0cedad06a5.svg";
export { ForwardRef as ReactComponent };